import {OrbitControlConstraint} from './OrbitControlConstraint';

declare var THREE: any;

export class CylinderConstraint extends OrbitControlConstraint {

  private geometry;
  private planes: any[] = [];

  constructor(envCylinder) {
    super();
    this.generatePlanes(envCylinder);
  }

  private generatePlanes(envCylinder) {
    const geometry = new THREE.Geometry().fromBufferGeometry(envCylinder.geometry);
    const vertices = geometry.vertices;
    geometry.faces.forEach(face => {
      const planePoint = vertices[face.a].clone().applyMatrix4(envCylinder.matrixWorld);
      const plane = new THREE.Plane().setFromNormalAndCoplanarPoint(face.normal, planePoint);
      plane.constant = Math.abs(plane.constant);
      plane.constant -= 300;
      this.planes.push(plane);
    });
  }

  check(camera, newPosition): boolean {
    let plane;
    for (let i = 0; i < this.planes.length; i++) {
      plane = this.planes[i];
      if (plane.distanceToPoint(newPosition) < 0) {
        return false;
      }
    }
    return true;
  }

  dispose(): void {
    this.planes.length = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/classes/orbitControlConstraint/CylinderConstraint.ts